<template>
  <transition name="fade" mode="out-in" appear>
    <div v-if="showHotspotContent && data" class="hotspot-overlay-content">
      <transition name="fade" mode="out-in">
        <ButtonClose
          v-if="!galleryFullscreen"
          @click.native="onCloseClick"
        />
      </transition>
      <v-container v-if="imagesGalleryExist" fluid fill-height>
        <transition name="fade" mode="out-in">
          <v-row v-show="!showContact" justify="center" align="center" class="fill-height ma-0">
            <v-col
              cols="12"
              md="7"
              align="center"
              class="pt-16 mt-6 mt-md-0 pt-sm-3 pr-md-16"
            >
              <Gallery
                v-if="!showVideo && data.hotspotGallery"
                :sku="data.SKU"
                :collection="data.hotspotGallery"
                :content360="(data.hotspotGallery360 || null)"
                @change-slide="onGallerySlideChange"
              />
            </v-col>
            <v-col
              v-if="captionExist && !galleryFullscreen"
              cols="12"
              md="3"
              class="pb-16 pb-sm-3"
            >
              <div class="description pr-6" :class="{'text-only': isTextOnly}">
                <p v-show="data.hotspotGallery.length > 1" class="mb-6">
                  {{ currentGalleryIndex }}/{{ data.hotspotGallery.length }}
                </p>
                <span>
                </span>
                <MarkdownBlock
                  v-if="data[$route.params.language+'Description']"
                  :text="data[$route.params.language+'Description']"
                  :inline="true"
                  linkify
                  tag="p"
                  class="mb-6"
                />
                <MarkdownBlock
                  v-if="data[$route.params.language+'Caption']"
                  :text="data[$route.params.language+'Caption']"
                  :inline="true"
                  linkify
                  tag="p"
                />
                <button
                  @click="openContactForm"
                  class="cta-contact mt-6"
                  v-if="data.SKU"
                >
                  {{ $root.allLanguages[$language.current].ctaGetInfo }}
                </button>
              </div>
            </v-col>
          </v-row>
        </transition>
        <transition name="fade" mode="out-in">
          <v-row v-show="showContact" align="center" class="fill-height">
            <v-col cols="12">
              <ContactForm @on-back="onBack" :product="data" />
            </v-col>
          </v-row>
        </transition>
      </v-container>
      <v-container v-else-if="mainVideoExist || videosGalleryExist" fluid fill-height>
        <v-row justify="center" align="center" class="fill-height ma-0">
          <v-col cols="12" md="8" class="pt-16 pb-16 pt-md-3 pb-md-3">
            <VideoGallery :videos="videos" />
            <v-row align="center" class="mt-4">
              <v-col cols="12" sm="6">
                <MarkdownBlock
                  v-if="data[$route.params.language+'Description']"
                  :text="data[$route.params.language+'Description']"
                  :inline="true"
                  linkify
                  tag="h4"
                  class="grow text-uppercase text-center"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <MarkdownBlock
                  v-if="data[$route.params.language+'Caption']"
                  :text="data[$route.params.language+'Caption']"
                  :inline="true"
                  linkify
                  tag="p"
                  class="columns mb-0"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else-if="isTextOnly" fluid fill-height class="didascalia">
        <transition name="fade" mode="out-in">
          <v-row v-show="!showContact" justify="center" align="center" class="fill-height ma-0">
            <v-col
              cols="12" sm="10" md="8" lg="6"
              :align="data._slug.indexOf('didascalia') > -1 ? '' : 'center'"
              class="content"
            >
              <h1
                v-if="data[$route.params.language+'Description']"
                v-html="data[$route.params.language+'Description']"
                :class="(data._slug.indexOf('didascalia') > -1 ? 'mb-8' : 'mb-2')"
                class="text-center text-uppercase"
              >
              </h1>
              <MarkdownBlock
                v-if="data[$route.params.language+'Caption']"
                :text="data[$route.params.language+'Caption']"
                :inline="false"
                tag="div"
                linkify
              />
              <button
                v-show="!(data._slug.indexOf('osteria') > -1) && !(data._slug.indexOf('didascalia') > -1)"
                @click="openContactForm"
                class="cta-contact mt-6"
              >
                {{ $root.allLanguages[$language.current].ctaGetInfo }}
              </button>
            </v-col>
          </v-row>
        </transition>
        <transition name="fade" mode="out-in">
          <v-row v-show="showContact" align="center" class="fill-height">
            <v-col cols="12">
              <ContactForm @on-back="onBack" :product="data" />
            </v-col>
          </v-row>
        </transition>
      </v-container>
    </div>
  </transition>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import GetHotspotInfo from '@/graphql/GetHotspotInfo.gql'
import ButtonClose from '@/atoms/ButtonClose.vue'
import VideoGallery from '@/atoms/VideoGallery.vue'
import Gallery from '@/atoms/Gallery.vue'
import ContactForm from '@/molecules/ContactForm.vue'

export default {
  name: 'HotspotOverlayContent',

  data () {
    return {
      data: null,
      GetHotspotInfo,
      showHotspotContent: false,
      showVideo: false,
      galleryFullscreen: false,
      showContact: false,
      currentGalleryIndex: 1
    }
  },

  components: {
    MarkdownBlock,
    ButtonClose,
    Gallery,
    ContactForm,
    VideoGallery
  },

  beforeMount () {
    this.checkRoute()
  },

  mounted () {
    this.$events.on('onGalleryFullscreen', (fullscreen) => {
      this.galleryFullscreen = fullscreen
    })
  },

  methods: {
    onCloseClick () {
      this.showContact = false
      this.data = null
      this.$router.push({ params: { hotspotContent: null } })
    },

    openContactForm () {
      this.showContact = true
      this.$events.$emit('onShowLogo')

      if (window.dataLayer) {
        const room = this.$route.params.roomName.split('-')[1]
        if (!this.data.SKU) { // CTA EXTRAS
          if (room === 'foliage' || room === 'osteria') {
            window.dataLayer.push({
              event: 'generic_event',
              eventCategory: 'Clicks on Extra CTAs',
              eventAction: room,
              eventLabel: 'Click on Contact CTA'
            })
          }
          if (room === 'bookstore') {
            window.dataLayer.push({
              event: 'generic_event',
              eventCategory: 'Clicks on Extra CTAs',
              eventAction: room,
              eventLabel: 'Click on Book Form'
            })
          }
        } else if (this.data._slug.includes('parfum')) { // profumo
          window.dataLayer.push({
            event: 'generic_event',
            eventCategory: 'Clicks on Perfume Hotspot',
            eventAction: this.data.SKU,
            eventLabel: 'Open Form'
          })
        }
      }
    },

    onBack () {
      this.showContact = false
      this.$events.$emit('onHideLogo')
    },

    checkRoute (routeValue) {
      if (this.$route.params.hotspotContent || (routeValue && routeValue.params.hotspotContent)) {
        this.showHotspotContent = true
        this.showVideo = false
        this.currentVideoIndex = 0
        this.$events.emit('onHotspotOpen')
        this.$events.emit('onHideLogo')
      } else {
        this.showHotspotContent = false
        this.$events.emit('onHotspotClose')
        this.$events.emit('onShowLogo')
      }
    },

    onGallerySlideChange (index) {
      this.currentGalleryIndex = index + 1
    }
  },

  computed: {
    imagesGalleryExist () {
      return (this.data.hotspotGallery && this.data.hotspotGallery.length > 0)
    },

    videosGalleryExist () {
      return (this.data.hotspotVideo && this.data.hotspotVideo.length > 0)
    },

    mainVideoExist () {
      return (this.data.mainVideoFile || this.data.mainVideoLink)
    },

    captionExist () {
      return (this.data[this.$route.params.language + 'Description'] ||
        this.data[this.$route.params.language + 'Caption'])
    },

    isTextOnly () {
      return (!this.imagesGalleryExist && !this.mainVideoExist)
    },

    videos () {
      const videoList = []
      if (this.data.mainVideoFile) {
        videoList.push({ videoFile: this.data.mainVideoFile })
      }
      if (this.data.mainVideoLink) {
        videoList.push({ videoLink: this.data.mainVideoLink })
      }
      if (this.videosGalleryExist) {
        this.data.hotspotVideo.forEach(video => {
          videoList.push({ videoLink: video.link })
        })
      }
      return videoList
    }
  },

  apollo: {
    HotspotInfo: {
      query: GetHotspotInfo,
      skip () {
        return !this.$route.params.hotspotContent
      },
      variables () {
        return {
          slug: this.$route.params.hotspotContent
        }
      },
      async result (resultData) {
        if (resultData.data) {
          this.data = this.HotspotInfo
        } else {
          this.data = null
        }
      }
    }
  },

  watch: {
    '$route' (newValue, oldValue) {
      this.checkRoute(newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0 !important;
}

.hotspot-overlay-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $c-pink;
  z-index: 20;

  @include breakpoint('md-and-down') {
    overflow-y: auto;
  }
}

h4 {
  font-size: 32px;
}

.cta-contact {
  outline: none;
  background-color: $c-white;
  padding: 6px 24px;
  border-radius: 100px;
  transition: all 0.25s $ease-in-out-quad;

  &:hover {
    background: $c-black;
    color: $c-white;
  }
}

.columns {
  column-count: 2;
  column-gap: 20px;
}

.didascalia {
  overflow-y: auto;

  .content {
    padding: 12% 20px;

    @include breakpoint ('xs-only') {
      padding: 30% 20px;
    }
  }

  h1 {
    line-height: 1;
  }
}
</style>
